<script>
import rpc from '@/odoorpc'

export default {
	components: {},
	props: {
		product_id: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
            infoPageData:{
                total:0,
                currentPage:1,
                page_Size:10,
            },
            dialogVisible:false,
            tableDataDetails:[],
        }
	},
	computed: {},
	methods: {
		info(product_id){

        this.dialogVisible = true
        rpc.web.dataset.call_kw({
            model:"product.encoding",
            method:"search_material_info",
            args:[],
            kwargs:{
                "product_id":product_id,
                "currentPage":this.infoPageData.currentPage,
                "pageSize":this.infoPageData.page_Size,
                }
            })
            .then(res=>{
                
                this.tableDataDetails = res.data
                this.infoPageData.total = res.total
            })
        },
        // 用料详情分页
        infoPageSize(page_size){
            this.infoPageData.page_Size = page_size
            this.info(this.product_id)

        },
        infoPageChange(pageNum){
            this.infoPageData.currentPage=pageNum
            this.info(this.product_id)
        },
        // 关闭对话框
        infoClose(){
            this.dialogVisible = false
            this.infoPageData.currentPage = 1
        },
	},
}
</script>

<template>
    <div>
        <el-button type="primary" size="mini" @click="info(product_id)">用料详情</el-button>
        <el-dialog
                  :visible.sync="dialogVisible"
                  :close-on-click-modal="false"
                  :close-on-press-escape="false"
                  :show-close="false"
                  width="98%"
              >

            <el-table
                :data="tableDataDetails"
                style="width: 100%"
                :header-cell-style="{'background-color': '#F1F4FF'}"
                >
                <el-table-column
                    prop="date"
                    label="日期"
                    >
                </el-table-column>
                <el-table-column
                    prop="picking_type"
                    label="作业类型"
                    >
                </el-table-column>
                <el-table-column
                    prop="order_id"
                    label="订单编号"
                    >
                </el-table-column>
                <el-table-column
                    prop="client_order_ref"
                    label="客户订单编号"
                    >
                </el-table-column>
                <el-table-column
                    prop="product_name"
                    label="规格型号"
                    >
                </el-table-column>
                <el-table-column
                    prop="qty_done"
                    label="完成数量"
                    >
                </el-table-column>
            </el-table>


            <span slot="footer" class="dialog-footer">
                <el-button type="danger" @click="infoClose">关闭</el-button>
                
            </span>

            <el-pagination
                background
                style="margin-top: 20px; text-align: right;"
                layout="total, sizes, prev, pager, next, jumper"
                :total="infoPageData.total"
                :current-page="infoPageData.currentPage"
                :page-size="infoPageData.page_Size"
                :page-sizes="[10, 30, 50]"
                @size-change="infoPageSize"
                @current-change="infoPageChange"
            >
            </el-pagination>

        </el-dialog>
    </div>
</template>

<style lang="scss">
</style>
